"use strict";

class ScrollSpy {

	constructor()
	{
		this._callbacks = [];
		this._locked = false;
		this._useAnimFrame = true;
		this._lastPosY = 0;
		this._useAnimFrame = _.isFunction(Modernizr.prefixed('requestAnimationFrame', window));

		this.scrollData = {
			posY: -1,
			direction: 0.1,
			directionDelta: 0
		};

		_.bindAll(this, 'scroll', 'update','register', 'unregister');
		$(window).on('scroll', this.scroll);
		this.scroll();
	}

	scroll()
	{
		if(!this._locked)
		{
			this._locked = true;

			if(this._useAnimFrame) requestAnimationFrame(this.update);
			else this.update();
		}
	}

	update()
	{
		let posY = $(window).scrollTop();

        if(this.scrollData.posY != posY)
        {
			let direction = this.scrollData.posY < 0
				? 0
				: Math.min(1, Math.max(-1, posY - this.scrollData.posY));

			if(this.scrollData.direction != direction)
			{
				this._lastPosY = posY;
				this.scrollData.direction = direction;
			}

			this.scrollData.directionDelta = posY - this._lastPosY;
            this.scrollData.posY = posY;

			this._callbacks.forEach(cb => cb(this.scrollData));
        }

		this._locked = false;
	}

	register(callback)
	{
		this._callbacks = _.uniq(this._callbacks.push(callback));
	}

	unregister(callback)
	{
		this._callbacks = _.without(this._callbacks, callback);
	}
}
